import {
  formatDistanceToNowStrict as formatDistanceToNowStrictDateFns,
  formatDistanceToNow as formatDistanceToNowDateFns,
  format as formatDateFns,
} from 'date-fns';
import i18n from 'src/locales/i18n';
import { getDateFnsLocale } from 'src/locales/libraryLocales';

export const format = (date, formatStr, options) => {
  return formatDateFns(date, formatStr, {
    locale: getDateFnsLocale(i18n.language),
    ...options,
  });
};

export const formatDistanceToNowStrict = (date, options) => {
  return formatDistanceToNowStrictDateFns(date, {
    locale: getDateFnsLocale(i18n.language),
    ...options,
  });
};

export const formatDistanceToNow = (date, options) => {
  return formatDistanceToNowDateFns(date, {
    locale: getDateFnsLocale(i18n.language),
    ...options,
  });
};
